import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import css from './ModuleGroupTag.module.scss';
import { ITag } from '../../../../../../entities/module/private-template-module-tag/api/types';
import { cutText } from '../../../../../../helpers/cutText';
import { PrivateTemplateTagControls } from '../../../../../../entities/template/private-template-tag/ui/controls/controls';
import { useHighlightRemaining } from '../hooks/useHighlightRemaining';

interface ModuleTagProps {
	tag: ITag,
	isActive?: boolean,
	styles?: string,
	onClick?: (id: number) => void,
	onDelete?: () => void,
	onUnbind?: () => void,
	onEdit?: () => void,
	search?: string,
	isControlsHidden?: boolean,
	editable?: boolean,
}

export const ModuleGroupTag = ({
	tag,
	onClick,
	isActive,
	onDelete,
	onUnbind,
	onEdit,
	styles,
	search = '',
	isControlsHidden = false,
	editable = false,
}: ModuleTagProps) => {
	const {
		id,
		name,
	} = tag;

	const clickHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		e.stopPropagation();
		if (onClick) {
			onClick(id);
		}
	};

	const tagName = useMemo(() => cutText(name, 28), [name]);
	const highlightedTagName = useHighlightRemaining(search, tagName);

	const [isIconShow, setIsIconShow] = useState(false);

	const onRoleMouseEnter = () => {
		if (onUnbind) {
			setIsIconShow(true);
		}
	};

	const onRoleMouseLeave = () => {
		if (onUnbind) {
			setIsIconShow(false);
		}
	};

	return (
		<div
			onMouseEnter={onRoleMouseEnter}
			onMouseLeave={onRoleMouseLeave}
			role="presentation"
			className={cx(css.wrapper, isActive && css.active, styles)}
		>
			<div
				className={css.checkbox}
				role="presentation"
				onClick={clickHandler}
			>
				{isActive && (
					<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M11.3337 1L4.00033 8.33333L0.666992 5"
							stroke="#0075FF"
							strokeWidth="1.33333"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				)}
			</div>
			<span className={css.text}>
				{search ? highlightedTagName : tagName}
			</span>

			{
				editable && (
					<div className={css.controls}>
						<PrivateTemplateTagControls
							isIconShow={isIconShow}
							onEdit={isControlsHidden ? undefined : onEdit}
							onDelete={isControlsHidden ? undefined : onDelete}
							onUnbind={onUnbind}
						/>
					</div>
				)
			}

		</div>
	);
};
